import { withSvgIcon } from './withSvgIcon';

export const OctagonWarningContainedIcon = withSvgIcon(
  <>
    <path
      d="M6.99325 2.86461C7.54685 2.31101 8.2977 2 9.08061 2L14.9194 2C15.7023 2 16.4531 2.31101 17.0068 2.86461L21.1354 6.99325C21.689 7.54685 22 8.2977 22 9.08061V14.9194C22 15.7023 21.689 16.4531 21.1354 17.0068L17.0068 21.1354C16.4531 21.689 15.7023 22 14.9194 22H9.08061C8.2977 22 7.54685 21.689 6.99325 21.1354L2.86461 17.0068C2.31101 16.4531 2 15.7023 2 14.9194L2 9.08061C2 8.2977 2.31101 7.54685 2.86461 6.99325L6.99325 2.86461Z"
      fill="currentColor"
    />
    <path
      d="M11.9996 15.0205C12.8218 15.0205 13.4889 15.6876 13.4889 16.5098C13.4886 17.3318 12.8216 17.998 11.9996 17.998C11.1777 17.9978 10.5115 17.3316 10.5113 16.5098C10.5113 15.6877 11.1776 15.0207 11.9996 15.0205ZM13.0846 6.00195C13.3023 6.00195 13.4737 6.18828 13.4557 6.40527L12.8971 13.1045C12.8809 13.2972 12.7203 13.4451 12.5269 13.4453H11.4996C11.3061 13.4453 11.1446 13.2974 11.1285 13.1045L10.5699 6.40527C10.5518 6.18836 10.7234 6.00209 10.941 6.00195H13.0846Z"
      fill="white"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
